/* eslint-disable @typescript-eslint/camelcase */
import { handleActions } from 'redux-actions';
import { AuthenticateState } from './interfaces';
import Types from './types';

const initialState: AuthenticateState = {
  isLoading: false,
  data: null,
  companySelected: null,
  partnerSelected: null,
  expiredSession: false,
  restrictions: {
    max_length: 0,
    min_length: 0,
    required_lower_case: false,
    required_numbers: false,
    required_special: false,
    required_upper_case: false,
  },
  isSuccess: false,
  mfaChangeRegion: {
    required: false,
    configured: false,
    qrcode_url: '',
    secret: '',
  },
};

export default handleActions(
  {
    [Types.AUTHENTICATE_REQUEST]: (state: AuthenticateState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.AUTHENTICATE_FULFILLED]: (
      state: AuthenticateState,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      data: { ...payload },
      expiredSession: false,
    }),
    [Types.AUTHENTICATE_REJECTED]: (state: AuthenticateState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.MFA_CHANGE_REGION_FULFILLED]: (
      state: AuthenticateState,
      { payload }
    ) => ({
      ...state,
      data: { ...state.data, token: payload.token },
      mfaChangeRegion: { ...payload.mfa },
      expiredSession: false,
      companySelected: null,
      partnerSelected: null,
    }),

    [Types.AUTHENTICATE_INVALIDATE_SESSION]: (state: AuthenticateState) => ({
      ...state,
      expiredSession: true,
      isLoading: false,
    }),

    'persist/REHYDRATE': (
      state: AuthenticateState,
      { payload }: { payload?: { authenticate?: AuthenticateState } }
    ) => ({
      ...state,
      ...(payload?.authenticate || {}),
      isLoading: false,
    }),

    [Types.AUTHENTICATE_MFA_REQUEST]: (state: AuthenticateState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.AUTHENTICATE_MFA_FULFILLED]: (
      state: AuthenticateState,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      data: {
        available_regions: state.data?.available_regions,
        logged_region: state.data?.logged_region,
        ...payload,
      },
      expiredSession: false,
    }),
    [Types.AUTHENTICATE_MFA_REJECTED]: (state: AuthenticateState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.SELECT_COMPANY]: (state: AuthenticateState, { payload }) => ({
      ...state,
      companySelected: payload,
    }),
    [Types.SELECT_PARTNER]: (state: AuthenticateState, { payload }) => ({
      ...state,
      partnerSelected: payload,
    }),
    [Types.FORGOT_PASSWORD_REQUEST]: (
      state: AuthenticateState,
      { payload }
    ) => ({
      ...state,
      ...payload,
      isLoading: true,
    }),
    [Types.FORGOT_PASSWORD_FULFILLED]: (state: AuthenticateState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.FORGOT_PASSWORD_REJECTED]: (state: AuthenticateState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REGISTER_PASSWORD_REQUEST]: (state: AuthenticateState) => ({
      ...state,
      isLoading: true,
      isSuccess: false,
    }),

    [Types.AUTH_CHECK_RESTRICTIONS_FULFILLED]: (
      state: AuthenticateState,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      restrictions: payload,
    }),
    [Types.AUTH_CHECK_RESTRICTIONS_REQUEST]: (state: AuthenticateState) => ({
      ...state,
      isLoading: true,
      isSuccess: false,
    }),

    [Types.REGISTER_PASSWORD_FULFILLED]: (
      state: AuthenticateState,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      data: { ...payload },
    }),

    [Types.REGISTER_PASSWORD_REJECTED]: (state: AuthenticateState) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
    }),

    [Types.TRUSTED_LOGIN_REQUEST]: (state: AuthenticateState) => ({
      ...state,
    }),

    [Types.TRUSTED_LOGIN_FULFILLED]: (state: AuthenticateState) => ({
      ...state,
    }),

    [Types.TRUSTED_LOGIN_REJECTED]: (state: AuthenticateState) => ({
      ...state,
    }),
  },
  initialState
);
